// Familles de dons (segmentation parrainage). Triade de couleurs cohérente et
// distincte, sûre quelle que soit la couleur d'accent de l'association (orange, bleu…).
//  • Ensemble      → gris clair neutre (le total)
//  • Dons réguliers → ardoise (slate) — identique à la carte de synthèse du Dashboard
//  • Parrainage     → accent de l'association (la famille « héros »)
export const SEG_META = {
  ensemble: { key: 'ensemble', label: 'Ensemble', short: 'Ensemble', color: '#94A3B8', seg: null },
  regulier: { key: 'regulier', label: 'Dons réguliers', short: 'Réguliers', color: '#5B6472', seg: 'regulier' },
  parrainage: { key: 'parrainage', label: 'Parrainage', short: 'Parrainage', color: 'var(--tenant-accent-500)', seg: 'parrainage' },
};

// Ordre d'affichage canonique.
export const SEG_ORDER = ['ensemble', 'regulier', 'parrainage'];

// Mappe une clé de famille vers le paramètre `segment` attendu par le backend.
export const segParam = (key) => (SEG_META[key] ? SEG_META[key].seg : null);
